
<template>
  <el-container style="height:100vh;justify-content:center;align-items:center;">
    <el-card style="width:400px;margin:auto;">
      <div slot="header"><span>密码重置申请</span></div>
      <el-form :model="form" ref="form" label-width="80px">
        <el-form-item label="院校代码">
          <el-select v-model="form.SID" placeholder="请选择院校">
            <el-option v-for="item in schools" :key="item.SID" :label="item.SNAME" :value="item.SID"/>
          </el-select>
        </el-form-item>
        <el-form-item label="用户编号">
          <el-input v-model="form.UID" placeholder="请输入用户编号"/>
        </el-form-item>
        <el-form-item label="用户类型">
          <el-select v-model="form.UCLASS" placeholder="请选择用户类型">
            <el-option label="管理员" value="管理员"/>
            <el-option label="教师" value="教师"/>
            <el-option label="专家" value="专家"/>
            <el-option label="学生" value="学生"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit" :loading="loading">发送重置邮件</el-button>
          <el-button @click="$router.push('/login')">返回登录</el-button>
        </el-form-item>
      </el-form>
      <el-alert v-if="msg" :title="msg" :type="msgType" show-icon style="margin-top:10px"/>
    </el-card>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      form: {
        SID: '',
        UID: '',
        UCLASS: ''
      },
      schools: [],
      loading: false,
      msg: '',
      msgType: 'success'
    }
  },
  created() {
    this.getSchools();
  },
  methods: {
    getSchools() {
      // 获取院校列表
      this.GetData(
        "sys_school", { spid: "0" },
        res => { this.schools = res.data.data; },
        err => {}
      );
    },
    submit() {
  this.msg = '';
  if (!this.form.SID || !this.form.UID || !this.form.UCLASS) {
    this.msg = '请填写完整信息';
    this.msgType = 'error';
    return;
  }
  this.loading = true;
  this.PostData(
    'request',
    this.form,
    res => {
      this.loading = false;
      if (res.data.error_code === 0) {
        this.msg = res.data.message;
        this.msgType = 'success';
      } else {
        this.msg = res.data.message;
        this.msgType = 'error';
      }
    },
    err => {
      this.loading = false;
      this.msg = err || '请求失败，请稍后再试';
      this.msgType = 'error';
    }
  );
}
  }
}
</script>